export const DeleteFileIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.75 4.48438C13.2525 4.23687 10.74 4.10938 8.235 4.10938C6.75 4.10938 5.265 4.18438 3.78 4.33438L2.25 4.48438"
				stroke="#EC404C"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.375 3.7275L6.54 2.745C6.66 2.0325 6.75 1.5 8.0175 1.5H9.9825C11.25 1.5 11.3475 2.0625 11.46 2.7525L11.625 3.7275"
				stroke="#EC404C"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.1344 6.85938L13.6469 14.4119C13.5644 15.5894 13.4969 16.5044 11.4044 16.5044H6.58937C4.49687 16.5044 4.42938 15.5894 4.34688 14.4119L3.85938 6.85938"
				stroke="#EC404C"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M7.75 12.375H10.2475" stroke="#EC404C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M7.125 9.375H10.875" stroke="#EC404C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
